/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_DeleteInputs */

const id_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus`)
};

const ms_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padam`)
};

const da_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet`)
};

const de_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const en_us2_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const es_es2_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const es_mx2_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const fil_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggalin`)
};

const fr_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const it_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina`)
};

const hu_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Törlés`)
};

const nl_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

const no_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slett`)
};

const pl_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const pt_br2_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const pt_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const ro_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Șterge`)
};

const fi_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista`)
};

const sv_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta bort`)
};

const vi_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa`)
};

const tr_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sil`)
};

const cs_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat`)
};

const bg_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтриване`)
};

const ru_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const uk_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити`)
};

const ar_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const hi_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const th_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบ`)
};

const ja_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_cn2_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const zh_hant1_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const ko_forms_review_delete = /** @type {(inputs: Forms_Review_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Forms_Review_DeleteInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_delete = /** @type {((inputs?: Forms_Review_DeleteInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_DeleteInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_delete(inputs)
	if (locale === "ms") return ms_forms_review_delete(inputs)
	if (locale === "da") return da_forms_review_delete(inputs)
	if (locale === "de") return de_forms_review_delete(inputs)
	if (locale === "en-US") return en_us2_forms_review_delete(inputs)
	if (locale === "es-ES") return es_es2_forms_review_delete(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_delete(inputs)
	if (locale === "fil") return fil_forms_review_delete(inputs)
	if (locale === "fr") return fr_forms_review_delete(inputs)
	if (locale === "it") return it_forms_review_delete(inputs)
	if (locale === "hu") return hu_forms_review_delete(inputs)
	if (locale === "nl") return nl_forms_review_delete(inputs)
	if (locale === "no") return no_forms_review_delete(inputs)
	if (locale === "pl") return pl_forms_review_delete(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_delete(inputs)
	if (locale === "pt") return pt_forms_review_delete(inputs)
	if (locale === "ro") return ro_forms_review_delete(inputs)
	if (locale === "fi") return fi_forms_review_delete(inputs)
	if (locale === "sv") return sv_forms_review_delete(inputs)
	if (locale === "vi") return vi_forms_review_delete(inputs)
	if (locale === "tr") return tr_forms_review_delete(inputs)
	if (locale === "cs") return cs_forms_review_delete(inputs)
	if (locale === "bg") return bg_forms_review_delete(inputs)
	if (locale === "ru") return ru_forms_review_delete(inputs)
	if (locale === "uk") return uk_forms_review_delete(inputs)
	if (locale === "ar") return ar_forms_review_delete(inputs)
	if (locale === "hi") return hi_forms_review_delete(inputs)
	if (locale === "th") return th_forms_review_delete(inputs)
	if (locale === "ja") return ja_forms_review_delete(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_delete(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_delete(inputs)
	return ko_forms_review_delete(inputs)
});
export { forms_review_delete as "forms.review.delete" }